import { ReactNode, useEffect } from 'react';
import {
  ContainerAuthRoute,
  WrapperAuthRoute,
  WrapperChildren,
} from './styles';

import { useAppDispatch } from '@/store';
import { loadUserPreferences, useConfig } from '@/store/slices/configSlice';
import { loadOeds } from '@/store/slices/oedsSlice';
import { Sidebar } from '../Sidebar';

type AuthLayoutProps = {
  children: ReactNode;
};

export function AuthLayout({ children }: AuthLayoutProps) {
  const dispatch = useAppDispatch();
  const { data } = useConfig();

  useEffect(() => {
    (async () => {
      if (!data.userPreferences) {
        await dispatch(loadOeds());
        await dispatch(loadUserPreferences());
      }
    })();
  }, []);

  return (
    <ContainerAuthRoute>
      <Sidebar />
      <WrapperAuthRoute>
        <WrapperChildren>{children}</WrapperChildren>
      </WrapperAuthRoute>
    </ContainerAuthRoute>
  );
}
